import React, { useEffect, useState } from 'react'
import LavorisService from '../../../services/LavorisService';
import { useSearchParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useAlert } from '../../../hooks/useAlert';
import { Modal } from '../../../components/others/Modal';
import { PhoneNumber } from '../../../components/others/PhoneNumber';
import { PrimaryButton } from '../../../components/others/ButtonPrimary';
import { getErrorMessage } from '../../../utils';
import { InputEmail } from '../../../components/others/InputEmail';
import { Input } from '../../../components/core/Input';
import AddressAutocomplete from '../../../components/others/MapsAutocomplete';
import { IndividualEmployeeResponseService } from '../../../services/Company/Employee.type';
type TProps = {
    show: boolean;
    onClose: Function;
    urlTittle?: string;
    refreshFunction: Function
};


const UpdateParcialEmployeeData = ({
    show,
    onClose,
    urlTittle,
    refreshFunction
}: TProps) => {
    const styles = "text-2xl text-red-500 font-bold";
    const LavorisInstance = LavorisService.getInstance();
    const [searchParams] = useSearchParams();
    const [isLoading, setIsLoading] = useState(false);
    const [isReady, setIsReady] = useState(false);
    const { showAlert } = useAlert()
    const employeeId = searchParams.get('rowId')
    const [employeeData, setEmployeeData] = useState<IndividualEmployeeResponseService>();
    const [lat, setLat] = useState('');
    const [lng, setLng] = useState('');
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
        setValue,
        setError,
        clearErrors,
        control,
        watch,
    } = useForm({
        mode: "all",
    });


    const getEmployeeProfile = async () => {
        try {
            const employeeProfile =
                await LavorisInstance.CompanyServices.getIndividualEmployee(
                    employeeId || ' '
                );
            if (!employeeProfile) return;
            if (employeeProfile) {
                setEmployeeData(employeeProfile);
                const arrayName = employeeProfile.name.split(',');
                const first_name = arrayName[1]
                    ? arrayName[1].trim()
                    : arrayName[0].trim();
                const last_name = arrayName[1] ? arrayName[0].trim() : '';
                reset({
                    ...employeeProfile
                });
                setValue('first_name', first_name);
                setValue('last_name', last_name);
                setIsReady(true)
            }
        } catch (e: any) {
            console.log(e);
        }
    };
    useEffect(() => {
        const getData = async () => {
            await getEmployeeProfile()
        }
        getData()
    }, [])

    const getAddressComponentByType = (
        type: string,
        locationObj: google.maps.places.PlaceResult,
        fullAdrss: boolean = true,
    ): string | null => {
        const addressComponents = locationObj.address_components;
        if (fullAdrss) {
            const adrsName = locationObj.formatted_address || ""
            return adrsName
        }
        if (addressComponents) {
            for (let i = 0; i < addressComponents.length; i++) {
                const component = addressComponents[i];
                if (component.types.includes(type)) {
                    return component.long_name;
                }
            }
        }
        return null;
    };
    const handleSelectAddress = (
        addressObject: google.maps.places.PlaceResult,
    ) => {
        setValue(
            "fullAddress",
            getAddressComponentByType("route", addressObject, true) +
            " "
        );

        setValue(
            "city",
            getAddressComponentByType("locality", addressObject, false) || "",
        );
        setValue(
            "province",
            getAddressComponentByType("administrative_area_level_1", addressObject, false) ||
            "",
        );
        setValue(
            "postalCode",
            getAddressComponentByType("postal_code", addressObject, false) || "",
        );

        if (
            addressObject &&
            addressObject.geometry &&
            addressObject.geometry.location
        ) {
            setLat(addressObject.geometry.location.lat().toString() || "");
            setLng(addressObject.geometry.location.lng().toString() || "");
        }
    };

    const onSubmit = async (data: any) => {
        setIsLoading(true);
        try {           
            let fullname = `${data.last_name.trim()}, ${data.first_name.trim()}`
            const body = {
                id: employeeId,
                userId: data.userId,
                DNI: data.DNI,
                phonenumber: data.phoneNumber,
                name: fullname.trim(),
                fullAddress: data.fullAddress.trim(),
                lat: lat || data.lat,
                lng: lng || data.lng,
                postalCode: data?.postalCode?.trim(),
                province: data?.province,
                city: data?.city,
                supplementaryReference: data?.supplementaryReference?.trim()
            }

            await LavorisInstance.CompanyServices.updateEmployeePartialData(body)
            onClose?.();
            refreshFunction?.()
        } catch (err) {
            console.log(err)
            showAlert(getErrorMessage({ title: 'Error', err }))
        } finally {
            setIsLoading(false);
        }
    }


    if (!isReady)
        return (
            <Modal
                show={show}
                modalTitle={`Editar`}
                titleStyle={styles}
                urlTittle={urlTittle}
                onClose={() => onClose?.()}
            >
                <h1 className="w-full flex justify-center text-red-500 font-bolder animate-pulse">
                    {' '}
                    Cargando...{' '}
                </h1>
            </Modal>
        );

    return (
        <Modal
            show={show}
            modalTitle={`Editar`}
            titleStyle={styles}
            urlTittle={urlTittle}
            onClose={() => onClose?.()}
        >
            <form
                onSubmit={handleSubmit(onSubmit)}
                className='flex flex-col gap-6 justify-start align-middle'>
                <Input
                    type="text"
                    label="Apellido"
                    fieldName="last_name"
                    register={register}
                    error={errors?.last_name}
                    required

                />
                <Input
                    type="text"
                    label="Nombre"
                    fieldName="first_name"
                    register={register}
                    error={errors?.first_name}
                    required

                />
                <Input
                    type="text"
                    label="DNI"
                    fieldName="DNI"
                    register={register}
                    error={errors?.DNI}
                />
                <PhoneNumber
                    control={control}
                    fieldName="phoneNumber"
                    label="Teléfono"
                    error={errors?.phoneNumber}
                    required
                />
                <AddressAutocomplete
                    onSelectAddress={handleSelectAddress}
                    type="text"
                    label="GEOLOCALIZAR DIRECCION (calle y numero unicamente)"
                    fieldName="fullAddress"
                    error={errors?.fullAddress}
                    required
                    defaultValue={employeeData?.fullAddress}

                />
                <Input
                    type="text"
                    label="Referencia Adicional (importante Ejemplo: Número de calle, Número de departamento,Número de piso  M:12 C:8, Barrio)"
                    fieldName="supplementaryReference"
                    register={register}
                    error={errors?.supplementaryReference}
                    //placeholder="Ejemplo: Número de calle, Número de departamento,Número de piso, M:12 C:8"
                    style={{ width: 'auto', height: '150px' }}

                />
                <Input
                    type="text"
                    label="Código postal (opcional)"
                    fieldName="postalCode"
                    register={register}
                    error={errors?.postalCode}

                // required
                />

                <div className="w-full flex justify-end">
                    <PrimaryButton
                        type="submit"
                        text="Actualizar"
                        styles="bg-red-500 font-bold text-white w-1/3"
                        disabled={isLoading}
                    />
                </div>
            </form>

        </Modal>
    )
}

export default UpdateParcialEmployeeData